// extracted by mini-css-extract-plugin
module.exports = {"container":"heatConsumptionsGraph_container__1n7M7"};